const SET_ARCHIVES = "SET_ARCHIVES"

export { SET_ARCHIVES}